import state from './moduloMaterialsState';
import actions from './moduloMaterialsActions';
import mutations from './moduloMaterialsMutations';
import getters from './moduloMaterialsGetters';

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
